import weixin from '../weixin';
import config from './config';
import env from '../env';
import Version  from '../Version';
import Clipboard from '../clipboard';
import { getPwd } from './pwd/pwd';
import { openPopUp } from './pwd/popup';
import { openMiddlePage } from './utils/helpers';

const APP_APP_ID = 'wxca942bbff22e0e51'; // 腾讯视频appId
const DEFAULT_KOULING_IMG = 'https://vfiles.gtimg.cn/vupload/20211026/c4b4061635216326216.png';
const DEFAULT_KOULING_TITLE = '腾讯视频为您推荐精彩活动，快来参与吧';
const WECHAT_SINGLE_PAGE_ID = 9999;

export const canGetInstallState = true;

export function ready() {
  return new Promise((resolve) => {
    if (typeof WeixinJSBridge === 'undefined') {
      document.addEventListener('WeixinJSBridgeReady', resolve, false);
    } else {
      resolve();
    }
  });
}

export async function getInstallState(conf = config) {
  await ready();
  return new Promise((resolve) => {
    WeixinJSBridge.invoke(
      'getInstallState',
      {
        packageName: conf.packageName,
        packageUrl: conf.packageUrl,
      },
      (n) => {
        const o = n.err_msg || n.errMsg; // `errMsg`是用于兼容macOs微信模拟器报错,真实环境应该是`err_msg`
        if (o.indexOf('get_install_state:yes') > -1) {
          resolve(true);
        } else {
          resolve(false);
        }
      },
    );
  });
}

async function weixinReady() {
  return new Promise((resolve) => {
    weixin.weixinReady(resolve);
  });
}

export async function launch(schemeUrl, options) {
  await weixinReady();
  return new Promise((resolve) => {
    const ua = navigator.userAgent;
    const versionStrArr = ua.match(/MicroMessenger\/([\d.]+)/);
    let kouling = '';
    /**
     * 判断是否无权限拉起 app
     * @param {*} res 微信回包
     * @returns {Boolean}
     */
    const noPermission = (res) => {
      if (res && res.err_msg) {
        // ios android err msg not the same em...
        return res.err_msg.indexOf('no permission') > -1 || res.err_msg.indexOf('access_denied') > -1;
      }
      return false;
    };

    /**
     * 跳转中间页
     */
    const jumpOpenAppPage = () => {
      if (window.location.href.indexOf('/h5/app/openapp') === -1) {
        // openapp 页面不跳转了
        const link = `https://film.qq.com/h5/app/openapp.html?schema=${encodeURIComponent(schemeUrl)}`;
        window.location.href = link;
      }
    };

    /**
     * 打开口令 ui 弹窗
     */
    const showPopup = () => {
      openPopUp(copyKouling, jumpOpenAppPage);
    };

    /**
     * 复制口令
     */
    const copyKouling = () => {
      new Clipboard({
        text: kouling,
        success: () => {},
        error: () => {
          jumpOpenAppPage();
        },
      });
    };

    /**
     * 生成口令
     */
    const getKouling = async () => {
      try {
        const params = {
          pageId: WECHAT_SINGLE_PAGE_ID,
          jumpUrl: encodeURIComponent(`txvideo://v.qq.com/Html5Activity?url=${encodeURIComponent(window.location.href)}`),
          overlapUrl: DEFAULT_KOULING_IMG,
          title: DEFAULT_KOULING_TITLE,
        };

        if (options) {
          params.title = options.title || DEFAULT_KOULING_TITLE;
          params.overlapUrl = options.img || DEFAULT_KOULING_IMG;
          if (options.keepUrl) {
            params.jumpUrl = encodeURIComponent(schemeUrl);
          }
        }
        const result = await getPwd(params);
        kouling = result.weixin[0].text;
        showPopup();
      } catch (error) {
        console.error(error);
        jumpOpenAppPage();
      }
    };

    if (
      versionStrArr
      && versionStrArr.length === 2
      && Version.compare(versionStrArr[1], '6.5.6')
    ) {
      if (ua.indexOf('iPad') !== -1 || !schemeUrl.match(/^(tenvideo2|txvideo):\/\//)) {
        try {
          WeixinJSBridge.invoke(
            'launchApplication',
            {
              schemeUrl,
            },
            (res) => {
              if (noPermission(res)) {
                getKouling();
              }
              resolve(res);
            },
          );
        } catch (e) {}
      } else {
        wx.invoke(
          'launchApplication',
          {
            appID: APP_APP_ID,
            extInfo: schemeUrl,
            parameter: schemeUrl,
          },
          (res) => {
            if (noPermission(res)) {
              getKouling();
            }
            resolve(res);
          },
        );
      }
    } else {
      window.location.href = schemeUrl;
    }
  });
}

export async function download(conf = config) {
  const isOpenAppPage = openMiddlePage();
  // 只有 openapp 中间页才拉起下载
  if (!isOpenAppPage) return;

  if (env.isIos) {
    return new Promise((resolve) => {
      WeixinJSBridge
        && WeixinJSBridge.invoke(
          'launchApplication',
          {
            schemeUrl: conf.download,
          },
          (res) => {
            resolve(res);
          },
        );
    });
  } if (env.isAndroid) {
    window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.qqlive';
  }
}

export default {
  canGetInstallState,
  ready,
  getInstallState,
  launch,
  download,
};
